import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cdf-info-cell',
  imports: [],
  host: {
    '[class.subgrid]': 'subgrid() !== undefined',
  },
  template: `
    <h4 class="text-neutral">
      @if (title()) {
        {{ title() }}
      } @else {
        <ng-content select="[title]" />
      }
    </h4>
    <div class="info-cell-content">
      @if (content()) {
        {{ content() }}
      } @else {
        <ng-content />
      }
    </div>
  `,
  styleUrl: './info-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoCellComponent {
  readonly title = input<string>();
  readonly content = input<string>();
  readonly subgrid = input(false, { transform: booleanAttribute });
}
